import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import Typography from '@material-ui/core/Typography';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import Box from '@material-ui/core/Box';

import { makeDialogTitleStyles, } from 'styles/components/availability';
import Button from 'common/components/Button';

type Props = {
    handleClose: () => void,
    open: boolean,
};

const LastSessionCartInfoDialog: React.FC<Props> = ({ open, handleClose, }) => {
    const dialogTitleClasses = makeDialogTitleStyles();

    return (
        <Dialog fullWidth
                maxWidth="sm"
                open={open}>
            <DialogTitle classes={dialogTitleClasses}
                         disableTypography>
                <Typography component="h4"
                            variant="h6">
                    Uwaga
                </Typography>
            </DialogTitle>
            <DialogContent>
                <DialogContentText>
                    W Twoim koszyku znajdują się produkty.
                </DialogContentText>
                <Box display="flex"
                     justifyContent="center"
                     margin="2.5rem auto 1rem"
                     maxWidth="18rem"
                     width="100%">
                    <Button onClick={handleClose}>
                        OK
                    </Button>
                </Box>
            </DialogContent>
        </Dialog>
    );
};

export default LastSessionCartInfoDialog;
